import { useDescope } from "@descope/react-sdk";
import AccountTree from "@mui/icons-material/AccountTree";
import { AppBar, Box, Container, Typography } from "@mui/material";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation,useNavigate } from "react-router-dom";

import pages from "../../constants/pages";
import { selectPageHeader } from "../../redux/pageHeaderSlice";
import {
	setEmail, setFirstName, setGroups,
	setIsCoAppSuperAdmin, setLastName, setOrganizationName, setOrgId, setPermissions,
	setPhone, setRoles, setUserId
} from "../../redux/userSlice";
import { NAV_DRAWER_TRANSITION_MS } from "../navigation/styled/sidebar-navigation.styled";
import CoAppProfile from "../global/components/CoAppProfile";
import PageHeader from "../global/components/PageHeader";

const HEADER_HEIGHT: number = 64;

export default function CoAppHeader({ leftOffset = 0 }) {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { logout } = useDescope();
	const pageHeaderState = useSelector(selectPageHeader);

	const handleUserLogout = useCallback(async () => {
		await logout();
		dispatch(setEmail(""));
		dispatch(setUserId(null));
		dispatch(setFirstName(""));
		dispatch(setGroups([]));
		dispatch(setLastName(""));
		dispatch(setPermissions([]));
		dispatch(setPhone(""));
		dispatch(setRoles([]));
		dispatch(setOrgId(null));
		dispatch(setIsCoAppSuperAdmin(false));
		dispatch(setOrganizationName(""));
		navigate(pages.login);
	}, [logout]);

	// used to render the Rule Builder header when creating / editing a rule
	const isRuleBuilderPage = location.pathname === pages.newRuleBuilder ||
		(location.pathname.startsWith("/rules/") && !location.pathname.includes("library") && !location.pathname.includes("trash"));

	return (
		<AppBar
			position="fixed"
			sx={(theme) => ({
				height: HEADER_HEIGHT,
				justifyContent: "center",
				ml: `${leftOffset}px`,
				width: `calc(100% - ${leftOffset}px)`,
				boxShadow: "none",
				borderBottom: "1px solid rgba(13, 31, 48, 0.06)",
				transition: theme.transitions.create(["margin-left", "width"], {
					easing: theme.transitions.easing.easeInOut,
					duration: NAV_DRAWER_TRANSITION_MS,
				}),
			})}
		>
			<Container
				maxWidth={false}
				disableGutters
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					height: HEADER_HEIGHT,
					px: 3,
				}}
			>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0, flex: 1 }}>
					{pageHeaderState.title ? (
						<PageHeader
							title={pageHeaderState.title}
							breadcrumbs={pageHeaderState.breadcrumbs}
							statusBadge={pageHeaderState.statusBadge}
						/>
					) : isRuleBuilderPage ? (
						// Pre-load fallback while the rule's name is still being fetched.
						<>
							<svg width="0" height="0">
								<defs>
									<linearGradient id="ruleBuilderGradient" x1="0%" y1="0%" x2="100%" y2="100%">
										<stop offset="0%" stopColor="#02D5AB" />
										<stop offset="100%" stopColor="#0A7FA8" />
									</linearGradient>
								</defs>
							</svg>
							<AccountTree sx={{ fontSize: 28, fill: "url(#ruleBuilderGradient)" }} />
							<Typography variant="h5" sx={{ fontWeight: 600, color: "rgba(13, 31, 48, 0.55)" }}>
								Loading rule…
							</Typography>
						</>
					) : null}
				</Box>
				<CoAppProfile handleLogout={handleUserLogout} />
			</Container>
		</AppBar>
	);
}
